import { AnyAction } from "redux";

import { VIEWPORTS } from "@ui/themes/ThemeInterface";

import { SET_VIEWPORT } from "./viewport.actions";

const initialState: VIEWPORTS = VIEWPORTS.MOBILE;

const viewportReducer = (
  store: VIEWPORTS = initialState,
  action: AnyAction,
): VIEWPORTS => {
  const { payload, type } = action;

  if (type === SET_VIEWPORT) {
    return payload;
  }

  return store;
};

export { viewportReducer };
